import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

/** A surface's look (DESIGN.md): white on the canvas, 22 px corners, flat, 24 px inside. `Section` shares it. */
export const SURFACE_CLASS = 'rounded-3xl bg-card p-6 text-card-foreground'

/**
 * A plain white block on the grey canvas, without a title (a titled one is a `Section`). Tables, empty notes and
 * wells inside it go flat (they look for `data-slot="surface"`). `className` is for placement, or `p-0` when its
 * content brings its own padding.
 */
export const Surface = ({ className, ...props }: ComponentProps<'div'>) => (
  <div data-slot="surface" className={cn(SURFACE_CLASS, className)} {...props} />
)
